import React from 'react'
import Box from '@mui/material/Box';
function DividerBlock({id,type,properties}) {
  return (
    <Box
            sx={{
             
              backgroundColor: properties.dividerbackgroundColor || '#cccccc',
              margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
              width: properties.width || '100%',
              display: properties.display || 'block',
              border: `${(parseFloat(properties.height || '1') / 2) || 0.5}px solid rgba(0,0,0,0.1)`,
            }}
          />
  )
}

export default DividerBlock